import { VueMotionCheckForExams } from 'domain/usecases/vue-motion/vue-motion-check-for-exams'
import { VueMotionRepository } from 'repository/interfaces/vue-motion-repository'

export class RemoteVueMotionCheckForExams implements VueMotionCheckForExams {
  private readonly vueMotionRepository: VueMotionRepository

  constructor(vueMotionRepository: VueMotionRepository) {
    this.vueMotionRepository = vueMotionRepository
  }

  load(
    params: VueMotionCheckForExams.Params
  ): Promise<VueMotionCheckForExams.Model> {
    return this.vueMotionRepository.vueMotionCheckForExams(params)
  }
}
